/* eslint-disable no-process-env */

import { AssistantLevel } from '@tribeplatform/gql-client/types'

const isTrue = (t?: string | boolean) => t === true || t === 'true'

/**
 * These variables are populated at runtime and are accessible for both server and client
 */

type TRuntimeConfigs = {
  IS_PROD: boolean
  GQL_ENDPOINT: string
  WS_ENDPOINT: string
  BETA_GQL_ENDPOINT: string
  APP_DOMAIN: string
  FORCED_NETWORK_DOMAIN: string
  SSOS_CALLBACK_URL: string
  UNSPLASH_ACCESS_KEY: string
  GIPHY_API_KEY: string
  SNOWPLOW_COLLECTOR_ADDRESS: string
  SNOWPLOW_ENABLE_PAGE_PING: boolean
  SNOWPLOW_ENABLE_PAGE_VIEW: boolean
  NODE_ENV: string
  FULLSTORY_ORGANIZATION_ID: string
  FULLSTORY_DEBUG_MODE: boolean
  RELEASE_CHANNEL: string
  OPTIMIZELY_SDK_KEY: string
  CLIENT_LOG_LEVEL: string
  SUPPORT_COMMUNITY_URL: string
  DASHBOARD_URL: string
  DD_ENABLED: boolean
  DD_RUM_APP_ID: string
  DD_RUM_CLIENT_TOKEN: string
  DD_RUM_SERVICE_NAME: string
  DD_PROFILER_ENABLED: boolean
  DD_RUM_SAMPLE_RATE: number
  SMART_SEARCH_LEVEL: AssistantLevel
}

export const RuntimeConfigs: TRuntimeConfigs = (env => {
  return {
    IS_PROD: env.NODE_ENV === 'production',
    GQL_ENDPOINT: env.GQL_ENDPOINT || env.TRIBE_GQL_ENDPOINT,
    WS_ENDPOINT: env.WS_ENDPOINT || env.TRIBE_WS_ENDPOINT,
    APP_DOMAIN: env.APP_DOMAIN || env.TRIBE_APP_DOMAIN,
    BETA_GQL_ENDPOINT: env.BETA_GQL_ENDPOINT || env.TRIBE_BETA_GQL_ENDPOINT,
    FORCED_NETWORK_DOMAIN: env.FORCED_NETWORK_DOMAIN,
    SSOS_CALLBACK_URL: env.SSOS_CALLBACK_URL,
    UNSPLASH_ACCESS_KEY: env.UNSPLASH_ACCESS_KEY,
    GIPHY_API_KEY: env.GIPHY_API_KEY,
    SNOWPLOW_COLLECTOR_ADDRESS: env.SNOWPLOW_COLLECTOR_ADDRESS,
    SNOWPLOW_ENABLE_PAGE_PING: isTrue(env.SNOWPLOW_ENABLE_PAGE_PING),
    SNOWPLOW_ENABLE_PAGE_VIEW: isTrue(env.SNOWPLOW_ENABLE_PAGE_VIEW),
    NODE_ENV: env.NODE_ENV,
    FULLSTORY_ORGANIZATION_ID: env.FULLSTORY_ORGANIZATION_ID,
    FULLSTORY_DEBUG_MODE: isTrue(env.FULLSTORY_DEBUG_MODE),
    RELEASE_CHANNEL: env.RELEASE_CHANNEL,
    OPTIMIZELY_SDK_KEY: env.OPTIMIZELY_SDK_KEY,
    CLIENT_LOG_LEVEL: env.CLIENT_LOG_LEVEL || 'info',
    SUPPORT_COMMUNITY_URL: env.SUPPORT_COMMUNITY_URL,
    DASHBOARD_URL: env.DASHBOARD_URL,
    DD_ENABLED: isTrue(env.DD_ENABLED),
    DD_RUM_APP_ID: env.DD_RUM_APP_ID,
    DD_RUM_CLIENT_TOKEN: env.DD_RUM_CLIENT_TOKEN,
    DD_RUM_SERVICE_NAME: env.DD_RUM_SERVICE_NAME,
    DD_PROFILER_ENABLED: isTrue(env.DD_PROFILER_ENABLED),
    DD_RUM_SAMPLE_RATE: parseInt(`${env.DD_RUM_SAMPLE_RATE || 0}`, 10),
    SMART_SEARCH_LEVEL:
      (env.SMART_SEARCH_LEVEL as AssistantLevel) || AssistantLevel.AMATEUR,
  }
})(typeof window !== 'undefined' ? window.RuntimeConfigs : process.env)

declare global {
  interface Window {
    RuntimeConfigs: {
      [K in keyof TRuntimeConfigs]: string
    } & {
      /**
       * Deprecated variables
       */
      TRIBE_GQL_ENDPOINT: string
      TRIBE_WS_ENDPOINT: string
      TRIBE_APP_DOMAIN: string
      TRIBE_BETA_GQL_ENDPOINT: string
    }
  }
}
